import axios from 'axios'
import { toastr } from 'react-redux-toastr'
import { initialize } from 'redux-form'
import { toLocalInputValue } from '../utils/datetime'

// STATES
const INITIAL_STATE = {
    list: [],
    show: 'list',
    errors: {}
}

const INITIAL_VALUES = { 
    title: '', 
    description: '',
    load: 0,
    general_status_id: null,
    course_id: null,
    // Herdado do prompt no backend quando o sinal não informa outro valor.
    min_result: 2
}

const LIST_URL = `${process.env.REACT_APP_API_HOST}/crash_signals?orderBy=date&sortedBy=desc&limit=200&with_results=1`

// ACTIONS
export function getList() {
    return fetchList(false)
}

/** Atualização em background (sem overlay de loading; não apaga a lista em erro de rede). */
export function refreshList() {
    return fetchList(true)
}

function fetchList(silent) {
    return dispatch => {
        axios.get(LIST_URL, { silent: !!silent })
            .then(resp => {
                dispatch({
                    type: 'CRASH_SIGNAL_FETCHED',
                    payload: resp
                })
            })
            .catch(e => {
                // Mantém lista atual em falha transitória (ERR_NETWORK_CHANGED, 401 intermitente, etc).
                if (!silent) {
                    const msg = (e.response && e.response.data && e.response.data.message)
                        || (e.message === 'Network Error' && 'Falha de rede ao carregar cronograma')
                        || 'Falha ao carregar cronograma'
                    toastr.error('Erro', msg)
                } else {
                    console.warn('refreshList silencioso falhou', e && e.message)
                }
            })
    }
}

export function getActualList() {
    return dispatch => {
        axios.get(
            `${process.env.REACT_APP_API_HOST}/crash_signals?orderBy=date&sortedBy=desc&limit=100`,
            { silent: true }
        )
            .then(resp => {
                dispatch({
                    type: 'CRASH_SIGNAL_UPDATE',
                    payload: resp
                })
            })
            .catch(e => {
                console.warn('getActualList falhou', e && e.message)
            })
    }
}

export function create(values) {
    return submit(values, 'post')
}

export function update(values) {
    return submit(values, 'put')
}

export function remove(values) {
    return submit(values, 'delete')
}

// Colunas gravaveis do sinal. Atributos calculados na listagem
// (around_results, crash_prompt, crash_prompt_title) fazem a ACL recusar o
// POST/PUT com 401.
const WRITABLE_FIELDS = [
    'date',
    'percent_to_start',
    'percent_after_lose',
    'percent_to_recovery',
    'percent_lost_to_stop',
    'value_lost_to_stop',
    'percent_win_to_stop',
    'value_win_to_stop',
    'wait_positive_signals',
    'martingale_steps',
    'predicted_position',
    'min_result',
    'user_id',
    'status',
    'source',
    'crash_prompt_id',
]

function submit(values, method) {
    return dispatch => {
        const id = values.id ? values.id + 0 : ''
        const filteredValues = {}
        WRITABLE_FIELDS.forEach(field => {
            if (values[field] !== undefined) filteredValues[field] = values[field]
        })

        dispatch(getValidation({}))
        axios[method](`${process.env.REACT_APP_API_HOST}/crash_signals${id ? '/'+id : ''}`, filteredValues)
            .then(resp => {
                // toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(init())
                dispatch(getList())
            })
            .catch(e => {
                if (!e.response) {
                    toastr.error('Erro', 'Desconhecido :-/')
                    console.log(e)
                } else if (!e.response.data) {
                    toastr.error('Erro', e.response.message)
                } else if (e.response.data.errors) {
                    dispatch(getValidation(e.response.data.errors))
                } else if (e.response.data) {
                    toastr.error('Erro', e.response.data.message)
                }
            })
    }
}

export function showContent(flag) {
    return {
        type: 'CRASH_SIGNAL_CONTENT_CHANGED',
        payload: flag
    }
}

export function showUpdate(crashSignal) {
    return [
        showContent('form'),
        initialize('crashSignalForm', {
            ...crashSignal,
            date: crashSignal.date ? toLocalInputValue(crashSignal.date) : crashSignal.date,
        })
    ]
}

export function showCreate() {
    return [
        showContent('form'),
        initialize('crashSignalForm', INITIAL_VALUES)
    ]
}

export function init() {
    return [
        initialize('crashSignalForm', INITIAL_VALUES),
        showContent('list')
    ]
}

export function getValidation(errors) {
    return {
        type: 'CRASH_SIGNAL_FORM_ERRORS',
        payload: errors
    }
}

//REDUCER
export const crashSignalReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CRASH_SIGNAL_FETCHED':
            return { ...state, list: action.payload.data ? action.payload.data.data : [] }

        case 'CRASH_SIGNAL_CONTENT_CHANGED':
            return { ...state, show: action.payload }

        case 'CRASH_SIGNAL_FORM_ERRORS':
            return { ...state, errors: action.payload }

        case 'CRASH_SIGNAL_UPDATE':
            let list = action.payload.data ? action.payload.data.data : []
            list.reverse()
            return { ...state, list: list }

        default:
            return state;
    }
}
